import React from 'react';
import QuestionIcon from "@material-ui/icons/QuestionAnswer";
import {
    Grid,
    Input,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";

const styles = theme => ({
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    selectInput: {
        marginTop: "0px",
        width: '100%'
    },
});

const SelectPullManifestComponent = ({classes, pullManifestStatuses, IsPullManifest, selectChange}) => {
    return (
        <div>
            <Grid container spacing={24}>
                <Grid item lg={3}>
                </Grid>
                <Grid item lg={6}>
                    <h1 className={'text-center text-primary'} style={{margin: 0}}>
                        <QuestionIcon style={{fontSize: '60px'}}/>
                    </h1>
                    <h4 className={'text-center'} style={{margin: 0}}>
                       Should manifest be pulled?
                    </h4>
                    <FormControl
                        className={classNames(classes.selectInput, classes.formControl)}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            {/*Airlines*/}
                        </InputLabel>
                        <Select
                            value={IsPullManifest}
                            onChange={selectChange}
                            input={<Input name="airline" id="airline-label-placeholder" />}
                            // displayEmpty
                            name="IsPullManifest"
                            className={classes.selectEmpty}
                        >
                            {pullManifestStatuses.map((option, i) => (
                                <MenuItem
                                    key={i}
                                    value={option.Id}
                                    className={classes.select}
                                >
                                    {option.Name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(SelectPullManifestComponent);



// WEBPACK FOOTER //
// ./src/views/AirlineRouteSettings/steps/PullManifest.js